/**
 * Mirrors Api\Enum\IntentionToHire.
 */
export enum IntentionToHire {
    SURE = 'sure',
    LIKELY = 'likely',
    UNSURE = 'unsure',
    JUST_ORIENTING = 'just_orienting',
}
